(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('page-anchor')) {
    class PageAnchor extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.anchors = this.getElementsByTagName('a');
        this.onClickHandler = this.onClick.bind(this);
        Array.from(this.anchors).forEach(element => {
          element.addEventListener('click', this.onClickHandler);
        });
      }

      disconnectedCallback() {
        Array.from(this.anchors).forEach(element => {
          element.removeEventListener('click', this.onClickHandler);
        });
      }

      onClick(e) {
        const id = decodeURIComponent(e.currentTarget.hash.replace(/^#/, ''));
        const target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    customElements.define('page-anchor', PageAnchor);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class PageHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.bars = document.getElementById('page-header-bars');

      this.onClickHandler = this.onClick.bind(this);
      this.bars.addEventListener('click', this.onClickHandler);
    }

    disconnectedCallback() {
      this.bars.removeEventListener('click', this.onClickHandler);
    }

    onClick(e) {
      e.preventDefault();
      this.classList.toggle('open')
    }
  }

  customElements.define('page-header', PageHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-visual"]) return;
  try {
    
  class IndexVisual extends HTMLElement {
    constructor() {
      super();

      this.images = Array.from(this.querySelectorAll('.iv-image'));
      this.dots = Array.from(this.querySelectorAll('.iv-dot'));
      this.dots.forEach((dot) => dot.addEventListener('click', this.linkToSlide.bind(this)));
      
      this.autoplaySpeed = 7000;
      
      this.activate(0);

      setTimeout(() => {
        this.classList.toggle('active', true)
      }, 1);
    }

    play() {
      clearTimeout(this.autoplay);
      this.autoplay = setTimeout(() => {
        this.activate(this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0)
      }, this.autoplaySpeed);
    }

    pause() {
      clearTimeout(this.autoplay);
    }

    activate(index) {
      this.currentIndex = index
      this.images.forEach((image, i) => image.classList.toggle('active', i == this.currentIndex));
      this.dots.forEach((dot, i) => dot.classList.toggle('active', i == this.currentIndex));
      this.play()
    }

    linkToSlide(event) {
      event.preventDefault();
      this.activate(this.dots.indexOf(event.currentTarget));
    }
  }

  customElements.define('index-visual', IndexVisual);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  if (!customElements.get('page-anchor')) {
    class PageAnchor extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.anchors = this.getElementsByTagName('a');
        this.onClickHandler = this.onClick.bind(this);
        Array.from(this.anchors).forEach(element => {
          element.addEventListener('click', this.onClickHandler);
        });
      }

      disconnectedCallback() {
        Array.from(this.anchors).forEach(element => {
          element.removeEventListener('click', this.onClickHandler);
        });
      }

      onClick(e) {
        const id = decodeURIComponent(e.currentTarget.hash.replace(/^#/, ''));
        const target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    customElements.define('page-anchor', PageAnchor);
  }

  } catch(e) { console.error(e); }
})();
})();
